import React, { useState, useRef, useLayoutEffect } from "react";
import { NavLink } from "react-router-dom";
import "./NavBar.scss";
import { options } from "../../../shared/shared.js";
import Logo from "../../../img/agroweb-logo.png";

export default function NavBar() {
  let navRef = useRef(null);
  const [dropDown, setDropDown] = useState(null);
  const [navBarName, setNavBarName] = useState("navBar");
  const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);

  useLayoutEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;

      setPrevScrollPos((prev) => {
        const isScrollingUp = prev >= currentScrollPos;
        const isNearTop = currentScrollPos < 350;
        setNavBarName(isScrollingUp || isNearTop ? "navBar" : "navBar small");
        return currentScrollPos;
      });
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleClick = () => {
    if (navRef.current) {
      navRef.current.scrollLeft = 0;
    }
  };

  const test = (options, lastIndex) => {
    if (window.innerWidth < 768) {
      return (
        <>
          <div className="nav-link-wrapper">
            <NavLink
              to={options[7].item_list[0].route + "/"}
              exact="true"
              className="nav-link"
              onClick={() => {
                handleClick();
              }}
            >
              {options[7].item_list[0].title}
            </NavLink>
          </div>
          <div className="nav-link-wrapper">
            <NavLink
              to={options[7].item_list[1].route + "/"}
              exact="true"
              className="nav-link"
              onClick={() => {
                handleClick();
              }}
            >
              {options[7].item_list[1].title}
            </NavLink>
          </div>
        </>
      );
    } else {
      return (
        <div className="links last">
          <div
            className="nav-link-wrapper"
            onMouseOver={() => {
              setDropDown(options[lastIndex].route);
            }}
            onMouseLeave={() => {
              setDropDown(false);
            }}
            onClick={() => {
              setDropDown(null);
            }}
          >
            <img src="/img/icons/threeDots.png" alt="" />
            <div className="botDiv">{items_list(options[lastIndex].route, options[lastIndex].item_list)}</div>
          </div>
        </div>
      );
    }
  };
  const navBarOptions = () => {
    const navOptArr = () => {
      const arr = options.slice(0, -1); // Uzimamo sve osim poslednjeg elementa

      if (window.innerWidth <= 768) {
        arr.splice(2, 1); // Uklanjamo element na indeksu 2 samo za manje ekrane
      }

      return arr;
    };
    let lastIndex = options.length - 1;
    return (
      <nav className="links" ref={navRef}>
        {navOptArr().map((option, index) => {
          return (
            <div
              className="nav-link-wrapper"
              key={index}
              onMouseOver={() => {
                setDropDown(option.route);
              }}
              onMouseLeave={() => {
                setDropDown(false);
              }}
              onClick={() => {
                handleClick();
                setDropDown(null);
              }}
            >
              <NavLink to={option.route} exact="true" className={`nav-link ${option.title}`}>
                {option.title}
              </NavLink>
              <div className="botDiv">{items_list(option.route, option.item_list)}</div>
            </div>
          );
        })}
        {test(options, lastIndex)}
      </nav>
    );
  };
  const getDropDownMenu = (setClass, items) => {
    const isOpen = dropDown === setClass ? "drop_down_menu" : "drop_down_menu close";
    const sizeClass = items.length > 6 ? "" : " small";

    return isOpen + sizeClass;
  };

  const items_list = (routes, items) => {
    if (items) {
      return (
        <ul
          className={getDropDownMenu(routes, items)}
          onMouseOver={() => {
            setDropDown(true);
          }}
        >
          {items.map((item, index) => {
            return (
              <NavLink key={index} to={item.route} exact="true">
                {item.title}
              </NavLink>
            );
          })}
        </ul>
      );
    }
  };
  return (
    <div className={`${navBarName}`}>
      <NavLink to="/" className="navBar-logo">
        <img src={Logo} alt="Logo - Agroweb.rs" />
      </NavLink>

      {navBarOptions()}
    </div>
  );
}
